import Api from './Api';

export default class ParametrosApi {

    all = async () => {
        return await Api.get('parametros').then(response => response.data)
            .catch((error) => console.log('[API.PARAMETROS.INDEX] ERROR\n', error));
    }

    informacoes_menu_historicos = 1;
    informacoes_menu_legislacoes = 2;
    informacoes_menu_acordos = 3;
    informacoes_menu_parceiros_url = 4;
    noticias_notificacoes_destaque_tempo = 5;
    noticias_notificacoes_publicacao_tempo = 6;
    robin_hood_historico_url = 7;
    historicos_texto = 8;
    rodape_exibir = 9;
    documentos_url = 10;
    faqs_video_url = 11;
    logo_cinza = 12;
    logo_exibir = 13;
    faqs_chatbot = 14;
    periodo_mes_atual = 15;

}